"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllowedOn = void 0;
const doesClaimAllowOn_1 = require("../../src/functions/doesClaimAllowOn");
function isAllowedOn(permissions, claims, record) {
    return Object.entries(permissions).reduce((status, permission) => {
        const [resource, action] = permission;
        // when status is false, false it ALWAYS returned
        // effect: 1 false on any permission and isAllowed = false
        return status
            // if there are no claims, false will be returned
            && !!claims.length
            // find 1 claim that grants access
            && !!claims.find(claim => (0, doesClaimAllowOn_1.doesClaimAllowOn)(claim, resource, action, record));
    }, true);
}
exports.isAllowedOn = isAllowedOn;
